import { STORAGE_KEY } from "@constants";
import { useEffect, useState } from "react";

/**
 * Manages the phone number for onboarding
 */
export const useOnboardingPhone = () => {
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    const phone = sessionStorage.getItem(STORAGE_KEY.ONBOARDING_PHONE);
    setPhone(phone ?? "");
  }, [setPhone]);

  const updatePhone = (phone: string) => {
    sessionStorage.setItem(STORAGE_KEY.ONBOARDING_PHONE, phone);
    setPhone(phone);
  };

  const clearPhone = () => {
    sessionStorage.removeItem(STORAGE_KEY.ONBOARDING_PHONE);
  };

  return {
    phone,
    updatePhone,
    clearPhone,
  };
};
